// extracted by mini-css-extract-plugin
export default {"card-product-container":"product_card-product-container__sugaC","card-product-item":"product_card-product-item__6eMiW"};